import { render, staticRenderFns } from "./DocumentPortalSetupConfigureView.vue?vue&type=template&id=ac648634&scoped=true&"
import script from "./DocumentPortalSetupConfigureView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSetupConfigureView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalSetupConfigureView.vue?vue&type=style&index=0&id=ac648634&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac648634",
  null
  
)

export default component.exports